module.exports = __webpack_public_path__ + "img/SUPPORT.ce4cd3ed.svg";